import { IMessage } from 'magpie-types';
import { defineMessage, InferMessageType } from '../internal-messaging';
import { ValueOf } from '../../types';

const sendMessage = defineMessage(
  'ct-link/send-message',
  (payload: IMessage) => payload
);

export const linkOperations = {
  sendMessage,
};

export type LinkOperation = InferMessageType<ValueOf<typeof linkOperations>>;
